<template>
  <v-app>
    <global-nav-drawer
      class="global-nav-draver"
      :smallerDrawer="smallerDrawer"
      v-if="getIsAuthenticated && !$route.meta.hideNavigation"
      ref="childComp"
    />
    <global-header-layout
      class="global-header-layout"
      v-if="getIsAuthenticated && !$route.meta.hideNavigation"
      :getIsAuthenticated="getIsAuthenticated"
      :drawer="drawer"
    >
      <template v-slot:barsBtn>
        <v-btn
          icon
          :class="{
            'hamburger-default-size': $vuetify.breakpoint.mdAndDown,
            'hamburger-lg-size': $vuetify.breakpoint.lgAndUp,
          }"
          class="hamburger-color"
          @click="miniDrawerClicked()"
        >
          <i class="buttonAction--text fa-light fa-bars"></i>
        </v-btn>
      </template>
    </global-header-layout>
    <v-main class="mb-10">
      <global-breadcrumbs></global-breadcrumbs>
      <transition name="bounce" mode="out-in">
        <router-view> </router-view>
      </transition>
    </v-main>
    <footer-index class="footer-index" bottom v-if="!$route.meta.hideFooter" />
  </v-app>
</template>
<!--      <speed-dial v-if="getIsAuthenticated"/>-->

<!--    <v-container v-if="!getIsAuthenticated" fluid fill-height>-->
<!--      <v-row class="text-center" justify="center">-->
<!--        <v-progress-circular-->
<!--            :size="50"-->
<!--            color="primary"-->
<!--            indeterminate-->
<!--        ></v-progress-circular>-->
<!--      </v-row>-->
<!--    </v-container>-->

<script>
import { mapGetters, mapActions } from "vuex";
import GlobalNavDrawer from "@/components/global/global-nav-drawer.vue";
import SpeedDial from "@/components/global/speed-dial.vue";
import FooterIndex from "@/components/footer/footer-index.vue";
import GlobalHeaderLayout from "@/components/global/global-header-layout.vue";
import GlobalBreadcrumbs from "@/components/global/global-breadcrumbs.vue";

export default {
  components: {
    SpeedDial,
    GlobalNavDrawer,
    FooterIndex,
    GlobalHeaderLayout,
    GlobalBreadcrumbs,
  },
  data() {
    return {
      smallerDrawer: false,
      drawer: true,
    };
  },
  // created() {
  //   this.checkAuthStatus().then(response => {
  //     if(response.data.status !== 'loggedin'){
  //       this.$router.push({name: 'Login'}).catch(() =>{})
  //     }
  //     // this.yolo = true;
  //   })
  // },
  mounted() {
    // const isAuthenticatedLocalStorage = JSON.parse(localStorage.getItem('isAuthenticated'));
    // if (isAuthenticatedLocalStorage) {
    //   this.checkAuthStatus();
    // }
  },
  methods: {
    ...mapActions(["checkAuthStatus"]),
    miniDrawerClicked() {
      this.smallerDrawer = !this.smallerDrawer;
      this.$refs.childComp.miniDrawerClicked();
    },
  },
  computed: {
    ...mapGetters(["getIsAuthenticated", "getRoles"]),
  },
};
</script>

<style lang="scss">
@import "@/style/main.scss";
@import "@/style/fontawesome/scss/fontawesome.scss";
$fa-font-path: "@/style/fontawesome/webfonts";
@import "@/style/fontawesome/scss/light.scss";
@import "@/style/fontawesome/scss/solid.scss";
@import "@/style/fontawesome/scss/regular.scss";

//.app-background
//  background-color: #F6F7F9 !important

.footer-index {
  height: 100%;
}

.global-nav-drawer {
  z-index: 12;
}
.global-header-layout {
  z-index: 12;
}
.hamburger-default-size {
  font-size: 1rem !important;
}

.hamburger-lg-size {
  font-size: 1.3rem !important;
}

.v-application {
  font-family: Arial, sans-serif !important;
}

.logo-color {
  color: #003088;
}

.second-heading-size {
  font-size: 0.8rem;
}

.version-style {
  color: #969696;
  font-size: 0.75rem;
}

.bounce-leave-active {
  animation: bounce-in 0.1s ease-out;
}

.bounce-enter-active {
  animation: bounce-out 0.1s ease-out;
}

@keyframes bounce-in {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(40px);
    opacity: 0;
  }
}

@keyframes bounce-out {
  0% {
    transform: translateX(-40px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
